import { Box, Grid } from '@mui/material';
import PaymentItem from './PaymentItem';

interface PaymentsProps {
  deposits: any[];
}

const Payments: React.FC<PaymentsProps> = ({ deposits }) => {
  return (
    <Box sx={{ direction: 'rtl' }}>
      <Grid container spacing={2}>
        {deposits.map((deposit, index) => (
          <Grid item xs={4} key={index}>
            <PaymentItem deposit={deposit} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Payments;
